<div class="validation-project-resume-table-container">
  @if (model) {
    <div class="validation-project-resume-table-header">
      <div class="validation-title blue" [innerHtml]="'validation.project-resume.title' | translate"></div>

      <div class="total-price" [innerHtml]="model.montantTotal | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></div>
    </div>
    <div class="validation-project-resume-table-data">
      <div class="table-data-row">
        <div class="table-data-line" id="funding">
          <div class="label-container">
            <div class="table-data-label" [innerHtml]="'validation.project-resume.conception' | translate"></div>
          </div>

          <div class="table-data-price">
            @if (discountApplied) {
              <div
                class="table-data-discount-value"
                [innerHtml]="model.totalPriceBom.amount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></div>
            }
            <div
              class="table-data-value"
              [innerHtml]="
                model.totalPriceBom.discountPrices[tunnelService.storageTunnelData?.discountValue].amount
                  | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
              "
              [ngClass]="{ 'text-danger': discountApplied }"></div>
          </div>
        </div>
      </div>

      <div class="table-data-row">
        <div class="table-data-line" id="funding">
          <div class="label-container align-items-center">
            <div class="table-data-label" [innerHtml]="'validation.project-resume.base-funding' | translate"></div>
            <div class="table-data-icon">
              <a href="javascript:" (click)="openComparatifFinancement()">
                <svg class="custom-icon">
                  <use xlink:href="assets/img/icons.svg#icon-compare"></use>
                </svg>
              </a>
            </div>
          </div>

          <div class="table-data-price flex-column align-items-end">
            @if (model.mensuality && model.duration) {
              <div
                class="table-data-value sub-total-price"
                [innerHtml]="
                  'validation.project-resume.base-funding-value'
                    | translate
                      : {
                          value: model.mensuality | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                          duration: model.duration,
                          interets: model.interest | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></div>
            }
            @if (model.downPayment > 0) {
              <p
                [innerHTML]="
                  'validation.project-resume.downPayment'
                    | translate
                      : {
                          value: model.downPayment | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></p>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="validation-fidelity-advantage">
      <ng-fidelity-advantage [model$]="fidelityAdvantageValidation.asObservable()"></ng-fidelity-advantage>
    </div>
  } @else {
    <div class="validation-project-resume-table-header">
      <div class="validation-title blue" [innerHtml]="'validation.project-resume.title' | translate"></div>
    </div>
    <div class="validation-project-resume-table-data">
      <div class="table-data-row">
        <p-skeleton styleClass="p-2"/>
      </div>
      <div class="table-data-row">
        <p-skeleton styleClass="p-2"/>
      </div>

      <div class="table-data-row">
        <p-skeleton styleClass="p-2"/>
      </div>
    </div>
  }
</div>
